<template>
  <div>
    <div class="mrB20" />
    <sui-grid
      ref="grid1"
      :columns="gridData1.columns"
      :dataset="'ds0'"
      :multiselect="true"
      :showDisplayCountControl="false"
    >
      <div class="comp_spacing" />
      <div class="btn_wrapL">
        <sui-button
          v-permission:create="pageId"
          type="button"
          class="comm_btn_gridTop"
          @click="onNewClick"
        >
          {{ $t('MSG_BTN_ADD') }}
        </sui-button>
        <sui-button
          v-permission:delete="pageId"
          type="button"
          class="comm_btn_gridTop"
          @click="onDeleteClick"
        >
          {{ $t('MSG_BTN_DEL') }}
        </sui-button>
      </div>
    </sui-grid>
    <!-- <sui-jqx-grid ref="grid1"
                :dataset="'ds0'"
                :columns="gridData1.columns"
                :columnsresize="true"
                :columnsautoresize="true"
                :editable="false"
                :selectionmode="'checkbox'"
                width="100%"
                height="190px"></sui-jqx-grid> -->
    <div class="comm_btn_wrap">
      <sui-button
        v-permission:update="pageId"
        type="button"
        class="comm_btn_solid"
        :disabled="checkMetaSave"
        @click="onSaveClick"
      >
        {{ $t("MSG_BTN_SAVE") }}
      </sui-button>
    </div>
  </div>
</template>
<script>
import BasePage from '~cm/components/BasePage';
export default {
  name: 'PGE_CMU_00001_T02', // eslint-disable-line vue/name-property-casing
  extends : BasePage,
  props: {
    pageId: {
      type: String,
      default: '',
    },
    selectedPageId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      gridDataServiceRegList: [],
      gridData1: {
        dataSource: {
          localdata: [],
          datatype: 'array',
          selectionmode: 'singlecell',
        },
        columns: [{
          text: this.$t('MSG_TXT_MDLE'),
          datafield: 'moduleName',
          width: 100,
        }, {
          text: this.$t('MSG_TXT_SMDLE'),
          datafield: 'subModuleName',
          width: 100,
        }, {
          text: this.$t('MSG_TXT_TYPE'),
          datafield: 'dataServiceTypeName',
          width: 100,
        }, {
          text: this.$t('MSG_TXT_DTSVC_ID'),
          datafield: 'dataServiceIdentification',
          width: 150,
        }, {
          text: this.$t('MSG_TXT_DTSVC_NM'),
          datafield: 'dataServiceName',
        }, {
          text: this.$t('MSG_TXT_DTSVC_URL'),
          datafield: 'dataServiceUniformresourcelocator',
        }],
      },
      localdata0: [],
      checkMetaSave: utils.checkMetaSave(),
    };
  },

  datasets: [{
    id: 'ds0',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { name: 'moduleName', type: 'string', map: 'moduleName' },
      { name: 'subModuleName', type: 'string', map: 'subModuleName' },
      { name: 'dataServiceTypeName', type: 'string', map: 'dataServiceTypeName' },
      { name: 'dataServiceIdentification', type: 'string', map: 'dataServiceIdentification' },
      { name: 'dataServiceName', type: 'string', map: 'dataServiceName' },
      { name: 'dataServiceUniformresourcelocator', type: 'string', map: 'dataServiceUniformresourcelocator' },
    ],
  }],
  watch: {
    selectedPageId(pageId) {
      if (!utils.isEmpty(pageId)) {
        this.getDataserviceRegList(pageId);
      } else {
        this.resetTab();
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.getDataserviceRegList(this.$props.selectedPageId);
    });
  },
  methods: {
    onNewClick() {
      utils.openLayerPopup('PGE_CMU_00005', this.onPagePopupCallback, {
        pageInitialData: { multiSelect: true },
        size: 'xlg',
      });
    },
    onPagePopupCallback(nodeData) {
      if (nodeData) {
        const addNewRows = [];
        nodeData.forEach(node => {
          const { dataServiceIdentification } = node;
          if (utils.findIndex(this.ds0.data, { dataServiceIdentification }) === -1) {
            addNewRows.push(node);
          }
        });
        if (addNewRows.length > 0) {
          this.ds0.addRows(addNewRows);
        }
      }
    },

    onDeleteClick() {
      const chkArr = this.ds0.getSelectedIndexes();
      if (chkArr.length) {
        // utils.confirm(this.$t('MSG_ALT_IS_DEL_DATA'), this.$t('MSG_TXT_YES'), this.$t('MSG_TXT_NO'),
        const delArr = [];
        // for (const i in chkArr) {
        //   if (typeof chkArr[i] !== 'number') continue;
        //   delArr.push(chkArr[i]);
        // }
        utils.forEach(chkArr, index => {
          if (typeof index === 'number') {
            delArr.push(index);
          }
        });
        this.ds0.deleteRows(delArr);
      } else {
        // utils.alert(this.$t('MSG_ALT_DEL_NO_DATA'), this.$t('MSG_BTN_CFRM'), () => false);
        //utils.messageBox('information', this.$t('MSG_ALT_DEL_NO_DATA'), null, () => false);
        utils.messageBox('alert', null, this.$t('MSG_ALT_NOT_SEL_ITEM'));
      }
    },

    onSaveClick() {
      if (utils.isEmpty(this.selectedPageId)) {
        //utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_PAGE')));
        utils.messageBox('alert', null, this.$t('MSG_ALT_NOT_SEL_ITEM'));
        return false;
      }

      const datasvcList = this.ds0.data;
      // if (datasvcList.length === 0) {
      //   utils.alert(this.$t('MSG_ALT_SAV_NO_DATA'), this.$t('MSG_BTN_CFRM'));
      //   return false;
      // }
      // utils.confirm(this.$t('MSG_ALT_IS_SAV_DATA'), this.$t('MSG_TXT_YES'), this.$t('MSG_TXT_NO'),
      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null,
        (/* ok */) => {
          const dataParams = [];
          // for (const i in datasvcList) {
          //   dataParams.push({
          //     pageId: this.$props.selectedPageId,
          //     dataServiceId: datasvcList[i].dataServiceIdentification,
          //   });
          // }
          utils.forEach(datasvcList, data => {
            dataParams.push({
              pageId: this.$props.selectedPageId,
              dataServiceId: data.dataServiceIdentification,
            });
          });
          http.request(this.pageId, 'DTS_CMU_00015', { // dataservices reg.
            path: {
              'page-id': this.$props.selectedPageId,
            },
            data: dataParams,
          }).then(() => {
            // utils.alert(this.$t('MSG_ALT_SVE_DATA'), this.$t('MSG_BTN_CFRM'));
            utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'), null);
            this.ds0.submit();
          }).catch(error => {
            console.log(error);
          });
        },
        (/* cancel */) => {});
    },
    getDataserviceRegList(pageId) {
      if (!pageId) return;
      http.request(this.pageId, 'DTS_CMU_00003', { // dataservices list in page
        path: {
          'page-id': pageId,
        },
      }).then(res => {
        this.gridData1.dataSource.localdata = [];
        this.gridDataServiceRegList = utils.cloneDeep(res.data);
        this.localdata0 = res.data;
        this.ds0.setRawData(this.localdata0);
      }).catch(error => {
        console.log(error);
      });
    },
    resetTab() {
      this.ds0.setRawData([]);    
    }
  }, // methods
};
</script>
<style scoped>
</style>
